import { render, staticRenderFns } from "./SupportEmail.vue?vue&type=template&id=a191340a&"
import script from "./SupportEmail.vue?vue&type=script&lang=js&"
export * from "./SupportEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports